import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 32px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding: 32px 8px;
  }
`;

export const QuestionWrapper = styled.div`
  max-width: 840px;
  width: 100%;
  height: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;

  .ant-image {
    width: fit-content;
  }

  & > p {
    margin: 0 !important;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
`;

export const CourseWrapper = styled.div`
  width: 100%;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: ${({ theme }) => theme.colors.black7};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const AnswersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 0;

  .ant-radio-group {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .ant-radio-wrapper {
    width: 100%;
    min-height: 48px;
    padding: 12px 0px 12px 16px;
    align-items: center;
    gap: 16px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.black4};
    background: ${({ theme }) => theme.colors.white};

    &.selected {
      border: 1px solid ${({ theme }) => theme.colors.black9};
      background: ${({ theme }) => theme.colors.white};
    }

    &.correct {
      border: 1px solid ${({ theme }) => theme.colors.green6};
      background: ${({ theme }) => theme.colors.green1};
    }

    &.incorrect {
      border: 1px solid ${({ theme }) => theme.colors.red6};
      background: ${({ theme }) => theme.colors.red1};
    }

    &:hover:not(.selected, .correct, .incorrect) {
      border: 1px solid ${({ theme }) => theme.colors.black4};
      background: ${({ theme }) => theme.colors.black1};
    }

    &:active {
      border: 1px solid ${({ theme }) => theme.colors.black9};
      background: ${({ theme }) => theme.colors.white};
    }

    & > span.ant-radio + * {
      width: 100%;
      padding-inline-end: 0 !important;
    }
  }
`;

export const FormulaWrapper = styled.div`
  display: flex;
`;

export const StyledImage = styled.img`
  width: fit-content;
  max-width: 100%;
`;
